const REACT_HOOK_ORDER_ERROR =
  /Minified React error #310\b|Rendered more hooks than during the previous render/i;

export const REACT_HOOK_ORDER_FINGERPRINT = 'react-error-310';

export function isReactHookOrderError(errorMessage: string): boolean {
  return REACT_HOOK_ORDER_ERROR.test(errorMessage);
}
